import styled from 'styled-components';

export default styled.tr`
  vertical-align: top;
`;
